import withSuspense from '@/hooks/withSuspense'
import { useFormContext } from '@/lib/form-contexts'
import {
  designCollectionsFilters,
  useCollections,
} from '@/lib/services/collections/collections.query'
import { sortCollectionsByName } from './designForm.utils'

const ButtonLinkSelector = ({ name, onChange = null }) => {
  const form = useFormContext()
  const { data: collections } = useCollections({ filters: designCollectionsFilters })
  const heroButtonLinkOptions = [
    { id: '/products', name: 'Shop All' },
    ...sortCollectionsByName(collections).map((c) => ({
      id: `/collections/${c.slug}`,
      name: c.name,
    })),
  ]

  return (
    <form.AppField name={name('props.buttonHref')} listeners={onChange ? { onChange } : undefined}>
      {(field) => <field.SelectInput options={heroButtonLinkOptions} label="Button destination" />}
    </form.AppField>
  )
}

export default withSuspense(ButtonLinkSelector)
